/**
 * Genesis Site welcome — Intake 완료 후 1회 `?genesis=welcome` (D18)
 * Site → Business handoff: sessionStorage 1회 플래그 (H5b)
 *
 * @see doc/system-completion-plan/04-gaps/TENANT_PORTAL_GAPS.md · D18
 */

import { logger } from '../logger';

export const GENESIS_WELCOME_PARAM = 'genesis';
export const GENESIS_WELCOME_VALUE = 'welcome';

/** Business plane 온보딩 투어 진입 경로 — Today (operator attention), not system index */
export const BUSINESS_GENESIS_TOUR_PATH = '/workspace';

const GENESIS_WELCOME_PENDING_KEY = 'inflomatrix.genesisWelcome.pending';

export interface GenesisWelcomeState {
  isWelcome: boolean;
  search: string;
}

/** URLSearchParams 또는 query string에서 genesis welcome 여부를 파싱한다. */
export function parseGenesisWelcome(search: string): GenesisWelcomeState {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const isWelcome = params.get(GENESIS_WELCOME_PARAM) === GENESIS_WELCOME_VALUE;
  return { isWelcome, search };
}

/** welcome 표시 후 URL에서 query param을 제거한 pathname+search를 반환한다. */
export function stripGenesisWelcomeSearch(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  params.delete(GENESIS_WELCOME_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}

/** Site plane welcome 감지 시 Business 투어 pending 1회 설정 (param strip 전 호출). */
export function setGenesisWelcomePending(): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(GENESIS_WELCOME_PENDING_KEY, '1');
  } catch (error) {
    logger.debug('Genesis welcome pending flag not stored (quota or private mode)', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
}

/** Business 진입 전 pending 여부 (consume 하지 않음). */
export function hasGenesisWelcomePending(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  try {
    return sessionStorage.getItem(GENESIS_WELCOME_PENDING_KEY) === '1';
  } catch (error) {
    logger.debug('Genesis welcome pending read failed', {
      error: error instanceof Error ? error.message : String(error),
    });
    return false;
  }
}

/** Business HomePage mount 시 1회 소비 — true면 투어 표시. */
export function consumeGenesisWelcomePending(): boolean {
  if (!hasGenesisWelcomePending()) return false;
  if (typeof sessionStorage === 'undefined') return false;
  try {
    sessionStorage.removeItem(GENESIS_WELCOME_PENDING_KEY);
  } catch (error) {
    logger.debug('Genesis welcome pending consume clear failed', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
  return true;
}

/** 테스트·Storybook reset */
export function clearGenesisWelcomePending(): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(GENESIS_WELCOME_PENDING_KEY);
  } catch (error) {
    logger.debug('Genesis welcome pending reset failed', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
}
